export const getSectors = ({token}) =>
  fetch(`${process.env.GATSBY_FUNCTION_PATH}/get-sectors`, {
    method: 'GET',
    headers: {
      token,
    },
  })

export const getSector = ({token, id}) =>
  fetch(`${process.env.GATSBY_FUNCTION_PATH}/get-sector?sectorId=${id}`, {
    method: 'GET',
    headers: {
      token,
    },
  })
